import React, { useState } from 'react'
import styled from 'styled-components'

import DeviceSearchHistory from 'types/SearchHistory'

import { color } from 'styles/colors'

type Props = {
  searchHistory: DeviceSearchHistory[]
  onClickCallBack: (query) => void
}

const SearchHistory = ({ searchHistory, onClickCallBack }: Props) => {
  const [showMore, setshowMore] = useState(false)

  const count = showMore ? 10 : 3

  return (
    <div>
      {searchHistory.length > 0 && (
        <S.SearchHistory>
          <h3>Recent Searches</h3>
          <ul>
            {searchHistory.map((search, index) => (
              index < count &&
              <S.SearchLink key={search.id + index.toString}>
                <S.Button onClick={() => onClickCallBack(search.query)}>{search.query}</S.Button>
              </S.SearchLink>
            ))}
            <S.Divider />
            <S.ShowMore onClick={() => setshowMore(!showMore)}>Show {showMore ? 'less' : 'more'} results</S.ShowMore>
          </ul>
        </S.SearchHistory>
      )}
    </div>
  )
}

export default SearchHistory

const S = {
  SearchHistory: styled.div`
    margin-top: 20px;
  `,
  SearchLink: styled.li`
    margin-bottom: 10px;
    display: flex;
  `,
  Button: styled.button`
    color: ${color('searchButton')};
    text-align: left;
    overflow-wrap: anywhere;
  `,
  ShowMore: styled.button`
    color: ${color('searchButton')};
    text-decoration: underline;
    font-weight: 700;
  `,
  Divider: styled.div`
    border-top: 1px solid ${color('border')};;
    padding-top: 15px;
    margin-top: 20px;
    width: 20%;
  `
}
